// Semanas de las fases del Cap 03 (pre, rodaje y post).
//
// Se pintan con decimales: con cero decimales un cierre de 0,8 semanas salía como "1" y un
// total de 7,8 como "8", así que parecía una semana entera aunque se cobraba 0,8.
export function fmtSemanas(n: number): string {
  return n.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

// Las fases van en semanas, pero se pueden escribir en días ("1d", "3 días"): se pasan a
// semanas con los días por semana del proyecto. Devuelve null si el texto no son días.
export function semanasDesdeDias(texto: string, diasPorSemana: number): number | null {
  const m = String(texto ?? '').trim().toLowerCase().match(/^(\d+(?:[.,]\d+)?)\s*(d|dia|día|dias|días)$/);
  if (!m || !(diasPorSemana > 0)) return null;
  const dias = parseFloat(m[1].replace(',', '.'));
  return Math.round((dias / diasPorSemana) * 10000) / 10000;
}

export const WEEKS_PER_MONTH = 4.33;

export function unitsFromPhaseWeeks(weeks: number, unitType: unknown, daysPerWeek: number): number | null {
  const unit = String(unitType ?? '').trim().toLowerCase();
  if (/^t\/a$/.test(unit)) return null;
  if (/^mes/.test(unit)) return Math.round((weeks / WEEKS_PER_MONTH) * 1e6) / 1e6;
  if (/^(jornada|d[ií]a|ses)/.test(unit)) return Math.round(weeks * daysPerWeek * 1e6) / 1e6;
  return weeks;
}

export function weeksFromUnits(units: number, unitType: unknown, daysPerWeek: number): number | null {
  const unit = String(unitType ?? '').trim().toLowerCase();
  if (/^t\/a$/.test(unit)) return null;
  if (/^mes/.test(unit)) return units * WEEKS_PER_MONTH;
  if (/^(jornada|d[ií]a|ses)/.test(unit)) return daysPerWeek > 0 ? units / daysPerWeek : null;
  return units;
}

export function weeksFromShootingDays(days: number, daysPerWeek = 5): number {
  const value = Number(days) || 0;
  return value > 0 && daysPerWeek > 0 ? Math.round((value / daysPerWeek) * 100) / 100 : 0;
}
